import { ApButtonSecondary, ApIcon, colors } from '@alixpartners/ui-components';
import React from 'react';
import { IFileUnknownError } from 'utils/types';
import {
  Container,
  ErrorIcon,
  ErrorsWrapper,
  Footer,
  Header,
  HeaderText,
  LineError,
  ShowErrorsButton,
  Wrapper,
} from './ErrorPanel.styles';

const isEmptyErrors = (err?: any) => {
  if (!err || !Object.keys(err)) {
    return true;
  }
  return Object.keys(err).every(
    (fileName) => !err[fileName] || Object.keys(err[fileName]).length === 0
  );
};

export const ErrorPanel = ({
  errors,
}: {
  errors: { [key: string]: any[] };
}) => {
  const [isExpanded, setExpanded] = React.useState(false);
  if (!isEmptyErrors(errors)) {
    return (
      <div>
        {Object.keys(errors).map((fileName) => {
          return errors[fileName].length ? (
            <Container key={`fileError-${fileName}`}>
              <Header>
                <Wrapper>
                  <ErrorIcon iconName="error" iconColor={colors.red1} />
                  <HeaderText>
                    You have {errors[fileName].length} errors from {fileName}
                  </HeaderText>
                </Wrapper>
                <Wrapper>
                  <ShowErrorsButton
                    role="button"
                    onClick={() => setExpanded(!isExpanded)}
                  >
                    {isExpanded ? (
                      <>
                        <div>Hide</div>
                        <ApIcon iconName="arrow_drop_up" />
                      </>
                    ) : (
                      <>
                        <div>Show</div>
                        <ApIcon iconName="arrow_drop_down" />
                      </>
                    )}
                  </ShowErrorsButton>
                </Wrapper>
              </Header>
              <ErrorsWrapper isExpanded={isExpanded}>
                {errors[fileName].map((err) => (
                  <LineError key={`${err.lineNumber}-${err.errors[0]}`}>
                    Line {err.lineNumber} {err.errors[0]}
                  </LineError>
                ))}
                <Footer>
                  <ApButtonSecondary
                    iconName="download"
                    onClick={() => {
                      const rows = errors[fileName].map((err) => [
                        `Line ${err.lineNumber}`,
                        ...err.errors,
                      ]);
                      let csvContent =
                        'data:text/csv;charset=utf-8,' +
                        rows.map((e) => e.join(',')).join('\n');
                      const encodedUri = encodeURI(csvContent);
                      const link = document.createElement('a');
                      link.setAttribute('href', encodedUri);
                      link.setAttribute('download', `${fileName}-errors.csv`);
                      document.body.appendChild(link); // Required for FF

                      link.click(); //
                    }}
                  >
                    Download errors
                  </ApButtonSecondary>
                </Footer>
              </ErrorsWrapper>
            </Container>
          ) : null;
        })}
      </div>
    );
  }
  return null;
};

export const ServerErrorPanel = ({ error }: { error?: IFileUnknownError }) => {
  if (!error) {
    return null;
  }
  return (
    <Container>
      <LineError>CorrelationId: {error.CorrelationId}</LineError>
      <LineError>ErrorMessage: {error.ErrorMessage}</LineError>
    </Container>
  );
};
